/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Set_Kind_UnknownInputs */

const en_us2_import_set_kind_unknown = /** @type {(inputs: Import_Set_Kind_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of the sets has a type this app does not know.`)
};

const pt_br2_import_set_kind_unknown = /** @type {(inputs: Import_Set_Kind_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma das séries tem um tipo que o app não conhece.`)
};

const es_419_import_set_kind_unknown = /** @type {(inputs: Import_Set_Kind_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una de las series tiene un tipo que la app no conoce.`)
};

const pt_pt2_import_set_kind_unknown = /** @type {(inputs: Import_Set_Kind_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma das séries tem um tipo que a app não conhece.`)
};

const fr_fr2_import_set_kind_unknown = /** @type {(inputs: Import_Set_Kind_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une des séries a un type que l'app ne connaît pas.`)
};

const de_de2_import_set_kind_unknown = /** @type {(inputs: Import_Set_Kind_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einer der Sätze hat einen Typ, den die App nicht kennt.`)
};

const it_it2_import_set_kind_unknown = /** @type {(inputs: Import_Set_Kind_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una delle serie ha un tipo che l'app non conosce.`)
};

/**
* | output |
* | --- |
* | "One of the sets has a type this app does not know." |
*
* @param {Import_Set_Kind_UnknownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const import_set_kind_unknown = /** @type {((inputs?: Import_Set_Kind_UnknownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Set_Kind_UnknownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_import_set_kind_unknown(inputs)
	if (locale === "es-419") return es_419_import_set_kind_unknown(inputs)
	if (locale === "pt-PT") return pt_pt2_import_set_kind_unknown(inputs)
	if (locale === "fr-FR") return fr_fr2_import_set_kind_unknown(inputs)
	if (locale === "de-DE") return de_de2_import_set_kind_unknown(inputs)
	if (locale === "it-IT") return it_it2_import_set_kind_unknown(inputs)
	return en_us2_import_set_kind_unknown(inputs)
});
export { import_set_kind_unknown as "import.set_kind_unknown" }